import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Provider } from "react-redux";
import { keycloak, isKeycloakEnabled } from "./keycloak";
import { store } from "./redux/store";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import "./i18n";
import App from "./App";
import { CustomErrorBoundary } from "@components/CustomErrorBoundary";

const initOptions = {
    onLoad: "login-required", // Force l'utilisateur à se connecter dès l'initialisation
    checkLoginIframe: true, // Active la vérification de session via iframe (détection logout sur d'autres onglets)
    checkLoginIframeInterval: 5, // Vérification toutes les 5 secondes (valeur raisonnable)
};

const dummyAuthClient: any = {
    init: () => Promise.resolve(true),
    login: () => Promise.resolve(),
    logout: () => Promise.resolve(),
    accountManagement: () => Promise.resolve(),
    register: () => Promise.resolve(),
    createLoginUrl: () => "",
    createLogoutUrl: () => "",
    createRegisterUrl: () => "",
    createAccountUrl: () => "",
    isTokenExpired: () => false,
    updateToken: () => Promise.resolve(true),
    loadUserInfo: () => Promise.resolve({}),
    authenticated: false,
    token: null,
    tokenParsed: null,
    subject: null,
    realmAccess: null,
    hasRealmRole: () => false,
    hasResourceRole: () => false,
    loadUserProfile: () => Promise.resolve({}),
    clearToken: () => {},
};
const AppWrapper = () => {
    const content = (
        <Provider store={store}>
            <BrowserRouter>
                <ErrorBoundary FallbackComponent={CustomErrorBoundary}>
                    <App />
                </ErrorBoundary>
            </BrowserRouter>
        </Provider>
    );

    return (
        <ReactKeycloakProvider
            authClient={
                isKeycloakEnabled && keycloak ? keycloak : dummyAuthClient
            }
            initOptions={initOptions}
        >
            {content}
        </ReactKeycloakProvider>
    );
};
ReactDOM.render(<AppWrapper />, document.getElementById("root"));
